import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "mb-2 mt-3" };
const _hoisted_2 = { class: "fw-bold" };
const _hoisted_3 = { class: "item" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    return (_ctx.schema?.options?.agb_Caption)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.schema?.options?.agb_Caption), 1)
            ]),
            _createElementVNode("div", {
                class: _normalizeClass(['mb-4 data-box__select', _ctx.hasConditionError ? 'bg-light border-danger text-danger' : ''])
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.data.conditionsconfirmed) = $event))
                        }, null, 512), [
                            [_vModelCheckbox, _ctx.data.conditionsconfirmed]
                        ])
                    ]),
                    _createElementVNode("div", null, [
                        _createVNode(_component_g_dynamic_html, {
                            template: _ctx.schema?.options?.agb_Text
                        }, null, 8, ["template"])
                    ])
                ])
            ], 2)
        ], 64))
        : _createCommentVNode("", true);
}
